import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyDashboardsRestoreRoute: InvariantJiraRoute = {
	name: 'legacy-dashboards-restore',
	path: '/secure/RestoreDefaultDashboard([!%]?[\\w]*).jspa',
};
